/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormGroupSchemaConfig } from '@gh/builder-shared';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getFormStateSnapshotValue,
  UserContext,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { DialogService } from '@gh/core-ui';
import { ChecklistsBusinessService } from '../../../resources';
import { ChklMasterInfo } from '../../../resources/checklists.model';

@Component({
             selector: 'gh-checklists-detail-top-form',
             template: require('./checklists-detail-top-form.component.html'),
             changeDetection: ChangeDetectionStrategy.OnPush,
           })
export class ChecklistsDetailTopFormComponent extends AbstractSnapshotFormComponent<ChklMasterInfo> implements OnChanges {
  @Output() openDocument = new EventEmitter<void>();
  @Output() preview = new EventEmitter<void>();
  @Output() masterInfoChange = new EventEmitter<FormStateSnapshot<ChklMasterInfo>>();
  // tslint:disable-next-line:no-input-prefix
  @Input() isParent: boolean;
  @Input() notEditable: boolean;
  // tslint:disable-next-line:no-input-prefix
  @Input() isParentEditable: boolean;
  @Input() handleError: boolean;

  constructor(private formStateBuilder: FormStateBuilder,
              private userContext: UserContext,
              private dialogs: DialogService,
              private business: ChecklistsBusinessService) {
    super();
  }

  get officeView(): boolean {
    return this.business.officeView;
  }

  onChange(): void {
    this.masterInfoChange.emit(this.state);
  }

  ngOnChanges(): void {
    if (this.handleError) {
      this.form.markAllAsTouched();
    }
  }

  protected buildForm(snapshot: FormStateSnapshot<ChklMasterInfo>): FormState<ChklMasterInfo> {
    return this.formStateBuilder.buildPlain({
      snapshot,
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      ...this.getFormSchemaConfig(getFormStateSnapshotValue(snapshot)),
    });
  }

  private getFormSchemaConfig(masterInfo: ChklMasterInfo): FormGroupSchemaConfig {
    return {
      children: {
        name: { required: true},
        notEditable: void 0,
      },
    };
  }
}
